import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, ExternalLink, Inbox, IndianRupee, Images } from "lucide-react";
import { http, TOKEN_KEY } from "../lib/api";
import { Logo } from "../components/site/Logo";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { InquiriesPanel } from "../components/admin/InquiriesPanel";
import { PricesPanel } from "../components/admin/PricesPanel";
import { GalleryPanel } from "../components/admin/GalleryPanel";

export default function AdminDashboard() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      nav("/admin/login");
    });
  }, [nav]);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    nav("/admin/login");
  };

  if (!user) return <div className="grid min-h-screen place-items-center bg-cream text-ink-soft">Loading…</div>;

  const tabCls = "gap-2 rounded-full px-4 py-2 data-[state=active]:bg-gold data-[state=active]:text-cream";
  return (
    <div className="min-h-screen bg-cream" data-testid="admin-dashboard">
      <header className="sticky top-0 z-30 border-b border-gold/20 bg-cream/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
          <Logo />
          <div className="flex items-center gap-2">
            <Link to="/" className="btn-ghost !px-4 !py-2" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /><span className="hidden sm:inline">View site</span></Link>
            <button onClick={logout} className="btn-ghost !px-4 !py-2" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" /><span className="hidden sm:inline">Logout</span></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10">
        <h1 className="font-serif text-4xl text-ink">Studio dashboard</h1>
        <p className="mt-1 text-sm text-ink-soft">Signed in as {user.email}</p>
        <Tabs defaultValue="inquiries" className="mt-8">
          <TabsList className="h-auto flex-wrap gap-1 rounded-full border border-gold/25 bg-white p-1.5">
            <TabsTrigger value="inquiries" className={tabCls} data-testid="admin-tab-inquiries"><Inbox className="h-4 w-4" />Inquiries</TabsTrigger>
            <TabsTrigger value="prices" className={tabCls} data-testid="admin-tab-prices"><IndianRupee className="h-4 w-4" />Prices</TabsTrigger>
            <TabsTrigger value="gallery" className={tabCls} data-testid="admin-tab-gallery"><Images className="h-4 w-4" />Gallery</TabsTrigger>
          </TabsList>
          <TabsContent value="inquiries" className="mt-8"><InquiriesPanel /></TabsContent>
          <TabsContent value="prices" className="mt-8"><PricesPanel /></TabsContent>
          <TabsContent value="gallery" className="mt-8"><GalleryPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
